var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.375 17.25h11.25V18H6.375zm0-3.75h11.25v.75H6.375zm0-3.75h11.25v.75H6.375zM11.625 6h6v.75h-6zM8.043 1.96L4.185 5.984l3.849-.01c.017-.53.012-3.702.009-4.015zm.932-.459L8.96 7.088l-1.905-.003L3.745 7l.005 15.5h16.125v-21zM7.889 0h13.486v24H2.625V5.874z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default ForwardRef;